import Vue from "vue";
import VueRouter, { isNavigationFailure, NavigationFailureType } from "vue-router";

import LandingView from "./../views/LandingView.vue";
import HomeView from "@/views/HomeView.vue";

import PortArView from "@/views/PortArView.vue";
// A aba de posicoes e um switch por produto (ETF x NDF) — ver PositionsTab.
import PositionsTab from "@/components/PortfolioPro/PositionsTab.vue";
import AnalyticsTab from "@/components/PortfolioPro/AnalyticsTab.vue";

import AnalyticsView from "@/views/FlowSight.vue";
import FlowSightEntrance from "@/views/FlowSightEntrance.vue";
// Dois conjuntos completos de paginas, um por produto. Sao copias de proposito:
// os relatorios de NDF e de spot nao compartilham colunas nem nocao de prazo, e
// a divergencia entre os charts tende a crescer, nao a diminuir.
import NdfOverview from "@/components/FlowSight/fxndf/Overview.vue";
import NdfConversions from "@/components/FlowSight/fxndf/Conversions.vue";
import NdfPortfolio from "@/components/FlowSight/fxndf/Portfolio.vue";
import SpotOverview from "@/components/FlowSight/fxspot/Overview.vue";
import SpotConversions from "@/components/FlowSight/fxspot/Conversions.vue";
import SpotPortfolio from "@/components/FlowSight/fxspot/Portfolio.vue";

import AutoHedgeView from "@/views/AutoHedgeView.vue";
import PlexusView from "@/views/PlexusView.vue";
import HedgeOSView from "@/views/HedgeOSView.vue";
import { useCoreStore, VEU_FADE_MS, VEU_ESPERA_MS } from "@/store/coreStore";
import { useAuthStore } from "@/store/authStore";
import { applyPageTitle, appForPath, baseOf } from "./pageTitle";
import TheQuartixMarkets from "@/views/TheQuartixMarkets.vue";
import MarketCommoditiesView from "@/views/MarketCommoditiesView.vue";
import MarketFXView from "@/views/MarketFXView.vue";
import MarketFixedIncome from "@/views/MarketFixedIncome.vue";
import BookView from "@/views/BookView.vue";
import AutoQuoteView from "@/views/AutoQuoteView.vue";


const routes = [
  // redireciona a raiz para /home (evita tela em branco)
  {
    path: "/login",
    name: "landing",
    component: LandingView,
    meta: { public: true },
  },
  {
    path:'/',
    redirect: '/home'
  },
  {
    path:'/home',
    component:HomeView
  },
  // O app se chamava Launchpad. O path antigo NAO pode sumir: o favorito
  // gravado no localStorage guarda o `path` do card, e uma sessao aberta antes
  // do rename continua pedindo /launchpad - sem redirect isso cai no catch-all
  // e o beforeEach devolve o mesmo path, em loop.
  { path: "/launchpad", redirect: "/marketdesk" },
  { path: "/launchpad/:tab", redirect: to => `/marketdesk/${to.params.tab}` },
  {
    path: "/autoquote",
    name: "autoquote",
    component: AutoQuoteView,
  },
  {
    path: "/marketdesk",
    name: "marketdesk",
    component: TheQuartixMarkets,
    redirect:'/marketdesk/fx-markets',
    children:[
      {
        path: 'commodities-markets',
        name: 'commodities-markets',
        component: MarketCommoditiesView
      },
      {
        path: 'fx-markets',
        name: 'fx-markets',
        component: MarketFXView
      },
      {
        path: 'fixed-income-markets',
        name: 'fixed-income-markets',
        component: MarketFixedIncome
      },
    ]
  },
  // FLOW.SIGHT. /flowsight e a tela de escolha do produto - ela fica FORA da
  // casca (AnalyticsView), porque a casca traz a sidebar de filtros de dataset,
  // que nao faz sentido antes de existir um produto escolhido.
  {
    path: "/flowsight",
    name: "flowsight",
    component: FlowSightEntrance,
  },
  {
    path: "/flowsight/ndf",
    component: AnalyticsView,
    redirect: "/flowsight/ndf/overview",
    children: [
      { path: "overview", name: "ndf-overview", component: NdfOverview },
      { path: "conversion", name: "ndf-conversion", component: NdfConversions },
      { path: "portfolio", name: "ndf-portfolio", component: NdfPortfolio },
    ],
  },
  {
    path: "/flowsight/spot",
    component: AnalyticsView,
    redirect: "/flowsight/spot/overview",
    children: [
      { path: "overview", name: "spot-overview", component: SpotOverview },
      { path: "conversion", name: "spot-conversion", component: SpotConversions },
      { path: "portfolio", name: "spot-portfolio", component: SpotPortfolio },
    ],
  },
  // Paths da versao anterior, quando so existia NDF e ele morava na raiz.
  { path: "/flowsight/overview", redirect: "/flowsight/ndf/overview" },
  { path: "/flowsight/conversion", redirect: "/flowsight/ndf/conversion" },
  { path: "/flowsight/portfolio", redirect: "/flowsight/ndf/portfolio" },
  //Nexus
  {
    path:'/nexus',
    name: 'nexus',
    component:()=>import('@/views/NexusView.vue')
  },
  // PORTFÓLIO (com filhos RELATIVOS)
  {
    path: "/portar",
    name: "portar",
    component: PortArView,
    redirect: "/portar/positions",
    props: true,
    children: [
      {
        path: "positions", // sem "/"
        name: "positions",
        props: true,
        component: PositionsTab,
      },
      {
        path: "analytics", // sem "/"
        name: "analytics",
        props: true,
        component: AnalyticsTab,
      },
    ],
  },

  {
    path: "/autohedge",
    name: "autohedge",
    component: AutoHedgeView,
  },
  // HedgeOS
  {
    path: "/hedgeos",
    name: "hedgeos",
    component: HedgeOSView,
  },
  {
    path: "/plexus",
    name: "plexus",
    component: PlexusView,
  },
  {
    path: "/book",
    name: "book",
    component: BookView,
  },

  // Paths antigos de /autohedge e /hedgeos. Nao e so bookmark: `selectedProduct`
  // vive no localStorage guardando o `path` do card, entao uma sessao aberta
  // antes do rename continua pedindo /auto-hedge. Sem estes redirects ela cai no
  // catch-all abaixo, que manda para "/", que o beforeEach devolve para o path
  // antigo - loop de redirecionamento, nao um 404.
  { path: "/auto-hedge", redirect: "/autohedge" },
  { path: "/hedge-os", redirect: "/hedgeos" },

  // catch-all para 404 (opcional)
 { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// A /home nao e uma aplicacao: appForPath devolve null ali de proposito, para o
// titulo da aba ficar so com o sufixo. Mas o veu precisa de um nome para
// mostrar, entao a casca ganha uma identidade so para esse fim.
const CASCA = {
  '/home': { name: 'Markets', icon: 'mdi-view-dashboard-outline' },
}

// A partir do vue-router 3.1, um guard que redireciona (`next(outroPath)`) faz a
// promise do push/replace REJEITAR com uma NavigationFailure. Nenhuma das
// chamadas de $router.push do projeto tem .catch, entao isso virava unhandled
// rejection e o overlay de dev acusava "Uncaught runtime errors" - foi o que
// aparecia ao vir do /login para um produto desabilitado.
// Aqui so as falhas ESPERADAS sao engolidas: redirect (o guard fez o seu
// trabalho), duplicated (clicou na rota em que ja esta) e cancelled (outra
// navegacao passou na frente). `aborted` e erro de verdade e segue propagando.
const FALHAS_ESPERADAS =
  NavigationFailureType.redirected |
  NavigationFailureType.duplicated |
  NavigationFailureType.cancelled

;['push', 'replace'].forEach((metodo) => {
  const original = router[metodo].bind(router)
  router[metodo] = function (local, aoConcluir, aoFalhar) {
    // Com callback, o vue-router nem devolve promise - deixa passar intacto.
    if (aoConcluir || aoFalhar) return original(local, aoConcluir, aoFalhar)
    return original(local).catch((erro) => {
      if (isNavigationFailure(erro) && (erro.type & FALHAS_ESPERADAS)) return erro
      throw erro
    })
  }
})

router.beforeEach((to, from, next) => {
  const coreStore = useCoreStore()

  // Sessao (ver a nota em authStore): rota publica e a que declara meta.public.
  // Logado indo para o login volta para /home; nao logado indo para o resto vai
  // para o login.
  const logado = useAuthStore().isAuthenticated
  const publica = to.matched.some((r) => r.meta && r.meta.public)
  if (publica) return logado ? next('/home') : next()
  if (!logado) return next('/login')

  const isDisabledRoute = coreStore.disabledBasePaths.some(base => to.path.startsWith(base))
  if (isDisabledRoute) return next('/home')

  const prod = coreStore.selectedProduct
  const target = coreStore.getSelectedUrl
  if (!prod || !target) return next()
  if (to.path === '/' && target && target !== '/') return next(target)

  // Veu de transicao, sob tres condicoes:
  //  - o destino tem nome: uma aplicacao, ou a /home via CASCA. Rota sem nome
  //    (o /login sai antes; qualquer path desconhecido) nao mostra veu.
  //  - a navegacao troca de app. Trocar de aba dentro do mesmo
  //    (/flowsight/overview -> /flowsight/conversion) nao remonta nada.
  //  - nao e a navegacao inicial (`from.matched` vazio = START_LOCATION): ali o
  //    proprio app ainda esta montando e o overlay nem existe para ser pintado.
  const destino = appForPath(to.path) || CASCA[baseOf(to.path)]
  if (destino && from.matched.length && baseOf(to.path) !== baseOf(from.path)) {
    coreStore.startNavigation(destino)
    // A troca de rota espera o veu terminar de APARECER, nao so de existir.
    // Duas coisas dependem disso:
    //  - o veu tem fade de VEU_FADE_MS; trocando antes, o destino monta por tras
    //    de um veu ainda semitransparente e da para ver a pagina trocando - o
    //    fundo hoje e 70% no centro e zero nas bordas, nao esconde mais nada;
    //  - a montagem do destino e sincrona e pesada (o Flow.Sight constroi os
    //    charts dc.js no mounted). Se ela comecar antes do primeiro paint, a
    //    main thread trava e o usuario ve o congelamento em vez do loading.
    // A margem de 40ms cobre o atraso entre setar a flag e o fade comecar;
    // VEU_ESPERA_MS e a pausa pedida entre o veu estar inteiro na tela e o
    // destino comecar a montar.
    setTimeout(() => next(), VEU_FADE_MS + 40 + VEU_ESPERA_MS)
    return
  }

  next()
})

// afterEach, nao beforeEach: o titulo so muda depois que a navegacao de fato
// aconteceu, entao uma rota barrada acima (produto desabilitado -> /home) nao
// deixa o nome do app na aba de uma pagina onde o usuario nunca entrou.
// Dispara tambem na navegacao inicial, cobrindo o load direto numa URL aninhada.
router.afterEach((to) => {
  applyPageTitle(to.path)

  // nextTick + rAF: espera o destino renderizar E pintar antes de comecar a
  // contar o tempo minimo do veu. Comecar em afterEach contaria durante a
  // montagem e o veu sairia junto com a tela ainda em branco.
  const coreStore = useCoreStore()
  if (!coreStore.navigating) return
  Vue.nextTick(() => requestAnimationFrame(() => coreStore.finishNavigation()))
})

// Chunk que falha ao baixar aborta a navegacao sem passar pelo afterEach. Sem
// isto o veu so sairia pelo timer de seguranca, oito segundos depois.
router.onError(() => {
  useCoreStore().finishNavigation()
})

export default router;
